import { render, staticRenderFns } from "./BookFormPage.vue?vue&type=template&id=0e032ef0"
import script from "./BookFormPage.vue?vue&type=script&lang=js"
export * from "./BookFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports